import { Button, Layout, theme, Form, Input, Spin, notification } from "antd";

import React, { useState } from "react";
import "../CreateRole/CreateRole.css";

import { Row, Col } from "antd";
import { Link, useNavigate } from "react-router-dom";
import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import ActionsApi from "../../common/Apis/ActionsApi";

const AddActions = () => {
  const navigate = useNavigate();
  const { Content } = Layout;
  const [loadings, setLoadings] = useState(false);

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleSubmit = (data) => {
    setLoadings(true);
    let formData = JSON.stringify({
      code: data.code,
      name: data.name,
    });
    ActionsApi.CreateActions(formData)
      .then((response) => {
        console.log(response);
        notification.open({
          message: (
            <span style={{ fontWeight: "bold" }}>{response.resultStatus}</span>
          ),
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        return navigate("/actions");
      })
      .catch((err) => {
        console.log(err);
        // Error Notification
        if (err.apiError.status) {
          notification.open({
            message: (
              <span style={{ fontWeight: "bold" }}>{err.apiError.status}</span>
            ),
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />

        <Content
          className="form-content nav-content"
          style={{
            margin: "16px 16px 0",
            padding: "30px",
            background: colorBgContainer,
          }}
        >
          <Form
            name="nest-messages"
            layout="vertical"
            className="FormClass"
            onFinish={handleSubmit}
          >
            <>
              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item
                    name="code"
                    label="Code"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Code.",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Code"
                      className="control-input"
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="name"
                    label="Name"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Action Name.",
                      },
                      {
                        pattern: /^[A-Za-z]+$/,
                        message: "Only alphabet characters are allowed.",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Name"
                      className="control-input"
                    />
                  </Form.Item>
                </Col>
              </Row>

              <div className="d-flex justify-content-end pt-5">
                <Link
                  type="primary"
                  to={""}
                  onClick={handleGoBack}
                  className="btn btn-primary btn-back"
                >
                  Back
                </Link>

                <Button
                  type="primary"
                  htmlType="submit"
                  className="btn btn-primary btn-save"
                >
                  Create {loadings == true && <Spin className="px-2" />}
                </Button>
              </div>
            </>
          </Form>
        </Content>
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};
export default AddActions;
